import React from 'react';
import Foot from '../svg/foot.svg';
import House from '../svg/house.svg';
import Plus from '../svg/plus.svg';
import Explore from '../svg/explore.svg';
import Bespoke from '../svg/bespoke.svg';

export default function Future() {
  return (
    <section className="-mt-px border-t border-primary">
      <h1 className="py-8 text-4xl font-bold text-center border-b border-primary">
        future plans
      </h1>
      <div className="flex flex-col items-baseline w-full sm:flex-row ">
        <div className="flex flex-col items-center self-center h-full px-8 py-16 border-r-0 md:px-4 sm:w-3/6 md:w-3/6 lg:w-3/6 md:border-r border-primary md:py-24 ">
          <Foot alt="carbon neutralt" width="50%" />
          <div className="px-6 text-center">
            <h2 className="pt-8 pb-2 text-2xl font-bold">carbon neutral</h2>
            <p className="max-w-sm text-sm opacity-80">
              aim to run at net zero carbon footprint – preserving the planet
              for the many generations to follow
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center self-center px-8 py-16 md:px-4 sm:w-3/6 md:w-3/6 lg:w-3/6 md:py-24 ">
          <House alt="in-house" width="50%" />
          <div className="px-6 text-center">
            <h2 className="pt-8 pb-2 text-2xl font-bold">in-house</h2>
            <p className="max-w-sm text-sm opacity-80">
              bring all parts of the business in-house to gain ultimate control
              of every piece of production
            </p>
          </div>
        </div>
      </div>
      <section className="flex flex-col items-baseline w-full border-t border-primary sm:flex-row">
        <div className="flex flex-col items-center self-center px-8 py-16 sm:w-2/6 md:w-2/6 lg:w-2/6 md:py-16 md:px-4">
          <Bespoke alt="organic plants" width="50%" />
          <div className="px-6 text-center">
            <h2 className="pt-8 pb-2 text-2xl font-bold">material design</h2>
            <p className="max-w-sm text-sm opacity-80">
              whats the unexplored, how and what new can we make
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center self-center px-8 py-16 border-0 sm:w-2/6 md:w-2/6 lg:w-2/6 md:py-24 md:px-4 sm:border-r sm:border-l border-primary">
          <Explore alt="stop sign with waste bins" width="50%" />
          <div className="px-6 text-center">
            <h2 className="pt-8 pb-2 text-2xl font-bold">explore new</h2>
            <p className="max-w-sm text-sm opacity-80">
              with the aims to play in other industries
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center self-center px-8 py-16 sm:w-2/6 md:w-2/6 lg:w-2/6 md:py-16 md:px-4">
          <Plus alt="organic plants" width="50%" />
          <div className="px-6 text-center">
            <h2 className="pt-8 pb-2 text-2xl font-bold">more more more</h2>
            <p className="max-w-sm text-sm opacity-80">
              we're just getting started, much more to come
            </p>
          </div>
        </div>
      </section>
    </section>
  );
}
